import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconShoppingCart } from '@redteclab/icons'

import { Button } from 'base-ui'

import { PRODUCT_ADD_TO_CART_FORM_ID } from '../../ProductAddToCartGroup/ProductAddToCartCta/ProductAddToCartCta'
import { useBuildAddToCartParams } from '../../ProductAddToCartGroup/ProductAddToCartCta/useBuildAddToCartParams'

export const ProductBuyBoxStickyAddToCart: FC = () => {
  const { disableCta } = useBuildAddToCartParams()

  return (
    <Button
      className="w-full"
      data-qa-id="add-to-cart-button-sticky"
      disabled={disableCta}
      form={PRODUCT_ADD_TO_CART_FORM_ID}
      startIcon={<IconShoppingCart />}
      type="submit"
    >
      <FormattedMessage id="general.button.label.addToCart" />
    </Button>
  )
}
